import { Route, Routes } from 'react-router-dom';

import RouteWithTitle from '../../../../src/routes/RouteWithTitle';
import AccessControl from '../../../components/AccessControl';
import { useCandidateAts, CandidateAtsAccess } from '../../../hooks/useCandidateAts';
import { Loader } from '../../conversationWidget/components/Loader';
import BulkUploadIndex from '../components/bulkUploadIndex/BulkUploadIndex';
import BulkImportSubmission from '../components/importSubmissions/BulkImportSubmission';
import BulkUpload from '../components/uploadFromDevice/UploadFromDevice';
import UploadDeviceSubmission from '../components/uploadFromDevice/UploadFromDeviceSubmission';
import UploadFromGoogleDrive from '../components/uploadFromGoogleDrive/UploadFromGoogleDrive';
import CandidateUploadHistory from '../components/uploadFromSpreadSheets/CandidateUploadHistory';
import UploadFromSpreadSheets from '../components/uploadFromSpreadSheets/UploadFromSpreadSheets';
import { UploadHistoryStatus } from '../components/uploadHistory';
import UploadHistory from '../components/uploadHistory/UploadHistory';

export const ImportCandidatesRoutes = () => {
  const isLocalImport = useCandidateAts(CandidateAtsAccess.LOCAL_IMPORT);
  const isGdriveImport = useCandidateAts(CandidateAtsAccess.GDRIVE_IMPORT);
  const isExcelImport = useCandidateAts(CandidateAtsAccess.EXCEL_IMPORT);
  return (
    <Routes>
      <Route
        path="/"
        element={
          <RouteWithTitle title="Bulk Upload- Wisestep">
            <BulkUploadIndex />
          </RouteWithTitle>
        }
      />
      <Route
        path="/submission"
        element={
          <RouteWithTitle title="Bulk Upload Submission- Wisestep">
            <BulkImportSubmission />
          </RouteWithTitle>
        }
      />
      <Route
        path="/bulk-upload-to-cv-parser"
        element={
          isLocalImport == undefined ? (
            <Loader />
          ) : isLocalImport ? (
            <BulkUpload />
          ) : (
            <AccessControl />
          )
        }
      />
      <Route
        path="/submission/bulk-upload-to-cv-parser"
        element={
          isLocalImport == undefined ? (
            <Loader />
          ) : isLocalImport ? (
            <UploadDeviceSubmission />
          ) : (
            <AccessControl />
          )
        }
      />
      <Route
        path="/bulk-upload-to-cv-parser/google-drive"
        element={
          isGdriveImport == undefined ? (
            <Loader />
          ) : isGdriveImport ? (
            <UploadFromGoogleDrive />
          ) : (
            <AccessControl />
          )
        }
      />
      <Route
        path="/bulk-upload-excel"
        element={
          isExcelImport == undefined ? (
            <Loader />
          ) : isExcelImport ? (
            <UploadFromSpreadSheets />
          ) : (
            <AccessControl />
          )
        }
      />
      <Route path="/bulk-upload-report" element={<UploadHistory />} />
      <Route path="/bulk-upload-report/gdrive" element={<UploadHistory />} />
      <Route
        path="/bulk-upload-excel/candidate-upload-history"
        element={<CandidateUploadHistory />}
      />
      <Route path="/bulk-upload-files-report/:batchId" element={<UploadHistoryStatus />} />
      <Route path="/bulk-upload-files-report/gdrive/:batchId" element={<UploadHistoryStatus />} />
    </Routes>
  );
};
